var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-1"},[(_vm.school.logoUrl)?_c('div',{staticClass:"profile",attrs:{"tile":""}},[_c('v-img',{attrs:{"width":"200px","height":"200","contain":"","src":_vm.school.logoUrl}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }